import { useEffect, useState } from "react";

const getMatches = (query: string, defaultValue: boolean): boolean => {
  if (typeof window === "undefined" || !window.matchMedia) {
    return defaultValue;
  }

  return window.matchMedia(query).matches;
};

export const useMediaQuery = (query: string, defaultValue = false): boolean => {
  const [matches, setMatches] = useState(() => getMatches(query, defaultValue));

  useEffect(() => {
    if (!window.matchMedia) return;

    const mediaQueryList = window.matchMedia(query);
    const updateMatches = (): void => {
      setMatches(mediaQueryList.matches);
    };

    updateMatches();
    if (mediaQueryList.addEventListener) {
      mediaQueryList.addEventListener("change", updateMatches);
    } else {
      mediaQueryList.addListener(updateMatches);
    }

    return () => {
      if (mediaQueryList.removeEventListener) {
        mediaQueryList.removeEventListener("change", updateMatches);
      } else {
        mediaQueryList.removeListener(updateMatches);
      }
    };
  }, [query]);

  return matches;
};
